// Small display helpers shared by the Agent Eval page and its learning-loop tabs.

import type { AxiosError } from 'axios';

export function formatTs(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export function formatUsd(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'number' ? value : Number(value);
  if (Number.isNaN(n)) return String(value);
  return `$${n.toFixed(2)}`;
}

/**
 * The message to show for a failed API call: FastAPI's `detail` when the
 * response carries one (a 409 from the curation FSM says which move was
 * illegal), else the error's own message.
 */
export function errorMessage(e: unknown, fallback: string): string {
  const ax = e as AxiosError<{ detail?: unknown }>;
  const detail = ax?.response?.data?.detail;
  if (typeof detail === 'string' && detail) return detail;
  if (detail && typeof detail === 'object') return JSON.stringify(detail);
  const msg = (e as Error)?.message;
  return msg || fallback;
}

export function pretty(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}
